module.exports = __webpack_public_path__ + "media/components/src/assets/images/embedded_parts/conversation2-b6f948165ad7f621bc1bd53585e53eeb.jpg";